import unveil from 'ui/lazy-load/unveil';

function init () {

	unveil('img.unveil[data-src]');

}

export default init;
